// src/components/Legal/TermoUso.js
import React from "react";
import { Box, Typography } from "@mui/material";

const TERMO_DATA = "01/06/2026";

const getEnv = (key, fallback = "") => {
    const v = process.env[key];
    return (v ?? fallback).toString().trim();
};

export default function TermoUso() {
    const CNPJ_EMPRESA = getEnv("REACT_APP_CNPJ_EMPRESA", "—");
    const NOME_EMPRESA = getEnv("REACT_APP_NOME_EMPRESA", "—");
    const EMAIL = getEnv("REACT_APP_EMAIL_EMPRESA", "—");

    return (
        <Box sx={{ px: 1 }}>
            <Typography variant="h6" gutterBottom fontWeight={700} align="center">
                Termo de Uso – Plataforma SaaS Docen
            </Typography>

            <Typography variant="subtitle2" sx={{ mb: 1, color: "text.secondary" }}>
                Data da última atualização: <b>{TERMO_DATA}</b>
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
                Este Termo de Uso regula a utilização da plataforma <b>“Docen”</b> fornecida
                pela empresa <b>{NOME_EMPRESA}</b>, sob CNPJ Nº <b>{CNPJ_EMPRESA}</b>,
                destinada à criação automatizada de documentos educacionais com apoio de
                Inteligência Artificial, alinhados à BNCC, permitindo edição,
                armazenamento e exportação pelo usuário.
            </Typography>

            {/* 1 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                1. Aceitação dos Termos
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                Ao acessar ou utilizar a Plataforma, o usuário declara que leu,
                compreendeu e concorda integralmente com estes Termos de Uso e com a
                Política de Privacidade, disponível na própria Plataforma. Caso não
                concorde, o usuário deve se abster de utilizar a solução.
            </Typography>

            {/* 2 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                2. Descrição da Solução
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                A Plataforma tem como finalidade gerar automaticamente atividades, provas
                e planos de aula com base nos parâmetros fornecidos pelo usuário,
                utilizando Inteligência Artificial para sugerir conteúdos textuais e
                visuais.
            </Typography>
            <Typography
                variant="body2"
                color="primary"
                sx={{ fontWeight: 600, mb: 1 }}
            >
                IMPORTANTE: O conteúdo gerado pela Plataforma possui caráter sugestivo e
                automatizado, não substituindo a análise pedagógica e metodológica do
                professor. É de inteira responsabilidade do usuário revisar, adaptar e
                validar todo material antes de sua aplicação em sala de aula.
            </Typography>

            {/* 3 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                3. Limitação de Responsabilidade
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Natureza do Conteúdo:</b> Os documentos gerados são baseados em dados
                e parâmetros informados pelo usuário e em algoritmos de IA, podendo não
                contemplar integralmente as necessidades pedagógicas ou contextos
                específicos em 100% dos casos.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Responsabilidade do Usuário:</b> Cabe exclusivamente ao usuário
                revisar o conteúdo, verificar sua adequação às diretrizes pedagógicas, à
                BNCC e às necessidades de seus alunos, bem como corrigir eventuais
                inconsistências.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Isenção de Responsabilidade:</b> A Plataforma, seus desenvolvedores,
                mantenedores e parceiros não se responsabilizam por quaisquer prejuízos,
                danos, reclamações, questionamentos jurídicos, ações disciplinares ou
                quaisquer consequências decorrentes do uso dos conteúdos gerados.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Erro de Dados:</b> A exatidão e adequação do conteúdo dependem
                diretamente das informações fornecidas pelo usuário. Dados incorretos ou
                mal interpretados poderão gerar resultados inadequados, sendo essa
                responsabilidade exclusiva do usuário.
            </Typography>

            {/* 4 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                4. LGPD – Tratamento de Dados Pessoais
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Coleta e Uso:</b> A Plataforma coleta e armazena apenas os dados
                necessários para funcionamento, geração de conteúdo e melhorias do
                sistema, em conformidade com a Lei Geral de Proteção de Dados Pessoais
                (Lei nº 13.709/2018 – LGPD).
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Finalidade:</b> Os dados fornecidos são utilizados exclusivamente
                para geração, personalização e histórico de documentos criados pelo
                usuário.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Contato e Suporte:</b> As informações de contato fornecidas pelo
                usuário, como e-mail e número de telefone, poderão ser utilizadas pela
                Plataforma para comunicações relacionadas ao funcionamento do serviço,
                suporte técnico, esclarecimento de dúvidas, envio de notificações
                operacionais, atualizações relevantes e contato ativo quando necessário,
                sempre em conformidade com a LGPD.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Compartilhamento:</b> Os dados não são compartilhados com terceiros,
                exceto em casos exigidos por lei, ordem judicial, consentimento expresso
                do usuário ou para serviços essenciais ao funcionamento da Plataforma.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Direitos do Titular:</b> O usuário pode solicitar a qualquer momento
                a revisão, atualização ou exclusão de seus dados pessoais, conforme
                previsto na LGPD, pelos canais de contato disponíveis.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Segurança:</b> São aplicadas medidas técnicas e administrativas para
                proteção dos dados contra acessos não autorizados, vazamentos e
                incidentes de segurança.
            </Typography>

            {/* 5 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                5. Propriedade Intelectual
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                Todo o software, funcionalidades, marca, logotipo, design e demais
                elementos da Plataforma pertencem à <b>{NOME_EMPRESA}</b>. É proibida a
                reprodução, cópia, distribuição ou uso não autorizado.
            </Typography>

            {/* 6 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                6. Alterações do Termo de Uso
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                A <b>{NOME_EMPRESA}</b> poderá atualizar este Termo de Uso a qualquer
                momento, sem aviso prévio. O uso continuado da Plataforma implica na
                aceitação das alterações.
            </Typography>

            {/* 7 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                7. Planos, Cobrança Recorrente e Alteração de Valores
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Cobrança Recorrente:</b> Quando aplicável, o acesso às funcionalidades
                pagas da Plataforma é disponibilizado mediante assinatura com cobrança{" "}
                <b>recorrente</b> (mensal), que será realizada automaticamente a cada
                ciclo, enquanto a assinatura permanecer ativa.
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Alteração de Plano (Upgrade):</b> O usuário poderá, conforme
                disponibilidade na Plataforma, solicitar a alteração do plano contratado{" "}
                (<b>upgrade</b>) a qualquer momento, por meio das configurações da conta
                ou dos canais de suporte.
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Alteração de Valor Conforme o Plano:</b> Ao alterar o plano, o valor
                da assinatura será ajustado de acordo com o plano selecionado e sua
                periodicidade vigente, passando a valer no próximo ciclo de cobrança,
                salvo quando a própria Plataforma indicar a aplicação imediata (por
                exemplo, liberação instantânea de recursos mediante cobrança proporcional
                ou diferença de valores).
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Alteração de Valores, Planos e Recursos:</b> Os valores dos planos,
                condições comerciais, limites de uso, funcionalidades e recursos
                disponíveis em cada plano poderão ser alterados pela <b>{NOME_EMPRESA}</b>
                a qualquer momento, sem aviso prévio, respeitados os ciclos de cobrança
                já contratados quando aplicável.
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Cancelamento:</b> O usuário pode cancelar a assinatura a qualquer
                momento. Após o cancelamento, o acesso às funcionalidades pagas deixará
                de ser disponibilizado, e será limitado conforme as regras do plano
                gratuito.
            </Typography>

            {/* 8 */}
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 2 }}>
                8. Disposições Gerais
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Vigência:</b> Este Termo permanece válido enquanto o usuário mantiver
                conta ativa na Plataforma.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
                <b>Contato:</b> Para dúvidas ou solicitações, entre em contato pelo
                e-mail: <b>{EMAIL}</b>
            </Typography>
        </Box>
    );
}